import { type ReactNode } from "react"
import { View } from "react-native"
import { useIsDesktop } from "@/hooks/useIsDesktop"
import { BFColumn } from "@/components/standard/screen/BFColumn"

export const BFDetailsScreen = ({
  mainScreen,
  details,
  hideDetails = false,
}: {
  hideDetails?: boolean
  mainScreen: ReactNode
  details: ReactNode
}) => {
  const isDesktop = useIsDesktop()
  return (
    <View className={"flex-1 flex-row justify-center"}>
      {isDesktop && (
        <View
          style={
            hideDetails
              ? {}
              : {
                  shadowOffset: {
                    height: 0,
                    width: 3,
                  },
                  shadowColor: "rgba(0,0,0,0.2)",
                  shadowRadius: 4,
                }
          }
          className="w-[450px] z-20"
        >
          <BFColumn>{mainScreen}</BFColumn>
        </View>
      )}

      <BFColumn
        className={hideDetails && isDesktop ? "hidden" : "max-w-[800px]"}
      >
        {details}
      </BFColumn>
    </View>
  )
}
